const makeInitialState = () => ({
  amount: ''
});

export default makeInitialState;

